var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center"},[(['ICON', 'ICON_AND_TEXT'].includes(_vm.displayType) && _vm.icon)?_c('img',{staticClass:"filter-icon mr-1",attrs:{"src":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.displayType !== 'ICON')?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }